// LIB
import React from 'react';
import styled from 'styled-components';

// STYLES
import { colors, fontSize, fontFamily } from '../../Design_System/DesignSystem';

// COMPONENTS
import { Text } from '../atoms/Text';
import { Icon } from '../atoms/Icon';
import { useLanguage } from '../../i18n/LanguageContext';

interface ThemeProps {
  ChangeColor(): void;
}

const RandomColor = ({ ChangeColor }: ThemeProps) => {
  const { t } = useLanguage();
  return (
    <MainColor onClick={() => ChangeColor()}>
      <Text
        color={colors.tan}
        fontSize={fontSize.small}
        fontFamily={fontFamily.tinos}
        bold={false}
        justify={false}
      >
        <>
          <Icon size={fontSize.mini} icon={'dot'} color={colors.tan} />{' '}
          <span> </span>
          {t.color}
        </>
      </Text>
    </MainColor>
  );
};

const MainColor = styled.div`
  display: flex;
  position: absolute;
  bottom: 10px;
  right: 40px;
  z-index: 3;
  cursor: pointer;
`;

export default RandomColor;
